const API_BASE_URL =
    process.env.REACT_APP_STAGE === "prod"
        ? 'https://license.ascom.com/api'
        : process.env.REACT_APP_STAGE === "staging"
            ? 'https://license-staging.ascom.com/api'
            : process.env.REACT_APP_STAGE === "test"
                ? 'https://license-test.ascom.com/api'
                : 'https://localhost:44370';

export const API_ACTIVATION_KEY_URL = API_BASE_URL + "/activationkey";
export const API_LICENSE_KEY_URL = API_BASE_URL + "/licensekey";
export const API_GET_LICENSES_URL = API_BASE_URL + "/getlicenses";
export const API_MODULE_INFORMATION_URL = API_BASE_URL + "/moduleinformation";